// @flow
import env from '../../environment';
import {deleteCreator, getCreator, postCreator, putCreator} from '../../http';

export const endpoints = Object.freeze({
  CREATE_SUB_CATEGORY: `${env.baseApiUrl}/im/admin/category/:categoryId/sub-category`,
  EDIT_SUB_CATEGORY: `${env.baseApiUrl}/im/admin/category/sub-category/:subcategoryId`,
  DELETE_SUB_CATEGORY: `${env.baseApiUrl}/im/admin/category/sub-category/:subcategoryId`,
  SORT_SUB_CATEGORY: `${env.baseApiUrl}/im/admin/category/:categoryId/sub-category/sort`,
  GET_SUBCATEGORIES: `${env.baseApiUrl}/im/admin/category/sub-category`,

  CREATE_SUB_CATEGORY_ITEM: `${env.baseApiUrl}/im/admin/sub-category-item`,
  EDIT_SUB_CATEGORY_ITEM: `${env.baseApiUrl}/im/admin/sub-category-item/:subCategoryItemId`,
  DELETE_SUB_CATEGORY_ITEM: `${env.baseApiUrl}/im/admin/sub-category-item/:subCategoryItemId`,
  SORT_SUB_CATEGORY_ITEM: `${env.baseApiUrl}/im/admin/sub-category-item/sort`,
});

export const getSubcategoriesApi = getCreator(endpoints.GET_SUBCATEGORIES);
export const createSubcategoryApi = postCreator(endpoints.CREATE_SUB_CATEGORY);
export const editSubcategoryApi = putCreator(endpoints.EDIT_SUB_CATEGORY);
export const sortSubcategoryApi = postCreator(endpoints.SORT_SUB_CATEGORY);
export const deleteSubcategoryApi = deleteCreator(
  endpoints.DELETE_SUB_CATEGORY
);

export const createSubcategoryItemApi = postCreator(
  endpoints.CREATE_SUB_CATEGORY_ITEM
);
export const editSubcategoryItemApi = putCreator(
  endpoints.EDIT_SUB_CATEGORY_ITEM
);
export const deleteSubcategoryItemApi = deleteCreator(
  endpoints.DELETE_SUB_CATEGORY_ITEM
);
export const sortSubcategoryItemApi = postCreator(
  endpoints.SORT_SUB_CATEGORY_ITEM
);
